export default "__VITE_ASSET__BqS$F9mI__"